package com.sddamico.components.widgets

import androidx.compose.runtime.Composable
import com.sddamico.SitePalette
import com.sddamico.models.TradeOfferResponse
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.LineHeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Div

private val tradeIndigo = Color.rgb(0x6366F1)

@Composable
fun TradeCard(trade: TradeOfferResponse) {
    val senderAssets = trade.assets.filter { it.fromClubId == trade.senderClubId }
    val receiverAssets = trade.assets.filter { it.fromClubId == trade.receiverClubId }

    Div(
        Modifier
            .fillMaxWidth()
            .backgroundColor(SitePalette.surface)
            .border(1.px, LineStyle.Solid, SitePalette.border)
            .borderRadius(8.px)
            .padding(1.cssRem)
            .toAttrs()
    ) {
        Column(Modifier.gap(0.375.cssRem)) {
            // Header: badge + club names
            Row(Modifier.gap(0.5.cssRem), verticalAlignment = Alignment.CenterVertically) {
                Div(
                    Modifier
                        .backgroundColor(tradeIndigo)
                        .borderRadius(4.px)
                        .padding(topBottom = 0.125.cssRem, leftRight = 0.5.cssRem)
                        .display(DisplayStyle.Flex)
                        .alignItems(AlignItems.Center)
                        .toAttrs()
                ) {
                    SpanText(
                        "Trade",
                        Modifier.fontSize(0.6875.cssRem).fontWeight(FontWeight.SemiBold).color(Colors.White)
                            .lineHeight(LineHeight.Normal)
                    )
                }
                SpanText(
                    "${trade.senderClubName} ↔ ${trade.receiverClubName}",
                    Modifier.fontSize(0.9375.cssRem).fontWeight(FontWeight.SemiBold).color(SitePalette.text)
                )
            }

            // Sender assets
            if (senderAssets.isNotEmpty()) {
                Column(Modifier.gap(0.125.cssRem)) {
                    SpanText(
                        "${trade.senderClubName} sends:",
                        Modifier.fontSize(0.8125.cssRem).fontWeight(FontWeight.Medium).color(SitePalette.textSecondary)
                    )
                    senderAssets.forEach { asset ->
                        val label = asset.playerName ?: asset.draftPickLabel ?: return@forEach
                        Row(Modifier.gap(0.375.cssRem), verticalAlignment = Alignment.CenterVertically) {
                            SpanText("• $label", Modifier.fontSize(0.875.cssRem).color(SitePalette.text))
                            if (asset.playerSport != null) {
                                SportBadge(asset.playerSport)
                            }
                        }
                    }
                }
            }

            // Receiver assets
            if (receiverAssets.isNotEmpty()) {
                Column(Modifier.gap(0.125.cssRem)) {
                    SpanText(
                        "${trade.receiverClubName} sends:",
                        Modifier.fontSize(0.8125.cssRem).fontWeight(FontWeight.Medium).color(SitePalette.textSecondary)
                    )
                    receiverAssets.forEach { asset ->
                        val label = asset.playerName ?: asset.draftPickLabel ?: return@forEach
                        Row(Modifier.gap(0.375.cssRem), verticalAlignment = Alignment.CenterVertically) {
                            SpanText("• $label", Modifier.fontSize(0.875.cssRem).color(SitePalette.text))
                            if (asset.playerSport != null) {
                                SportBadge(asset.playerSport)
                            }
                        }
                    }
                }
            }

            // Metadata
            Row(Modifier.gap(0.75.cssRem)) {
                SpanText(
                    "Completed: ${(trade.resolvedAt ?: trade.createdAt).substringBefore("T")}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
                SpanText(
                    "By: ${trade.createdByName}",
                    Modifier.fontSize(0.75.cssRem).color(SitePalette.textMuted)
                )
            }

            // Notes
            if (trade.notes != null) {
                SpanText(
                    trade.notes,
                    Modifier.fontSize(0.8125.cssRem).fontStyle(FontStyle.Italic).color(SitePalette.textSecondary)
                )
            }
        }
    }
}
